import styled from 'styled-components';

export const FlexPage = styled.div`
  overflow-y: auto;
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;
